import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://omgwcmqastewylltshdu.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9tZ3djbXFhc3Rld3lsbHRzaGR1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzA0Mjc5MzIsImV4cCI6MjA0NjAwMzkzMn0.Dd82cSB_T2fKSQgBW4oQtFtAMFVXC1gkjW78FaVIoF8';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  global: {
    headers: {
      'X-Client-Info': 'supabase-js-web',
    },
  },
});

export async function checkSupabaseConnection() {
  try {
    const { error } = await supabase
      .from('subscriptions')
      .select('id')
      .limit(1);
    if (error) throw error;
    return true;
  } catch (error) {
    console.error('Supabase connection error:', error);
    return false;
  }
}
